module.exports = __webpack_public_path__ + "img/tbank.38f91535.svg";